export const REFERRAL_TYPE = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  EXTERNAL_SESSION: 'externalSession'
}

export const REFERRAL_TYPE_MAP = {
  [REFERRAL_TYPE.INTERNAL]: '站內-瀏覽量',
  [REFERRAL_TYPE.EXTERNAL]: '站外-瀏覽量',
  [REFERRAL_TYPE.EXTERNAL_SESSION]: '站外-工作階段'
}

export const REFERRAL_TYPE_OPTIONS = [
  {
    label: REFERRAL_TYPE_MAP[REFERRAL_TYPE.EXTERNAL_SESSION],
    value: REFERRAL_TYPE.EXTERNAL_SESSION
  },
  {
    label: REFERRAL_TYPE_MAP[REFERRAL_TYPE.EXTERNAL],
    value: REFERRAL_TYPE.EXTERNAL
  },
  {
    label: REFERRAL_TYPE_MAP[REFERRAL_TYPE.INTERNAL],
    value: REFERRAL_TYPE.INTERNAL
  }
]

export const NON_PVGA_REFERRAL_TYPE_OPTIONS = [
  {
    label: REFERRAL_TYPE_MAP[REFERRAL_TYPE.INTERNAL],
    value: REFERRAL_TYPE.INTERNAL
  },
  {
    label: REFERRAL_TYPE_MAP[REFERRAL_TYPE.EXTERNAL],
    value: REFERRAL_TYPE.EXTERNAL
  }
]
